import React, { useContext, useState } from 'react';
import { AppContext } from "../../context/app/appContext";
import { useFormik } from "formik";
import { FreeTrialSingleTeamFormValidationSchema } from "../../utilities/Validations";
import { Button } from 'semantic-ui-react'

export const TeamItemTrial = ({ id, name, budget, size, onDelete, expenseLimit = 0, editInProgress, resetEditInProgress, teamData, selectTeam, setSelectTeam, nextButtonClicked }) => {

    // export const Team = ({id, name, budget, size, onDelete, onEdit, expenseLimit = 0, onSave, onCancel, editInProgress, resetEditInProgress, teamData, setClickTeamName,}) => {
    const [teamName, setTeamName] = useState(name);
    const [teamBudget, setTeamBudget] = useState(budget);
    const [teamExpenseLimit, setTeamExpenseLimit] = useState(expenseLimit);
    const [teamSize, setTeamSize] = useState(size);
    const [editable, setEditable] = useState(false);
    const appContext = useContext(AppContext);

    const teamForm = useFormik({
        initialValues: {
            teamName: name,
            teamBudget: budget,
            teamExpenseLimit: expenseLimit,
        },
        validationSchema: FreeTrialSingleTeamFormValidationSchema,
        onSubmit: async (values) => {
            console.log({ teamForm: values });
            const teamUpdateAction = await appContext.updateTeam({
                ...teamData,
                name: teamForm.values.teamName,
                budget: teamForm.values.teamBudget,
                expenseLimit: teamForm.values.teamExpenseLimit,
            });
            console.info({ teamUpdateAction });
            setTeamName(teamForm.values.teamName)
            setTeamBudget(teamForm.values.teamBudget)
            setTeamExpenseLimit(teamForm.values.teamExpenseLimit)
            setTeamSize(teamForm.values.teamSize)
            console.log({ teamName, teamSize, teamBudget, teamExpenseLimit })
            setEditable(false);
            resetEditInProgress();
        },
    });

    const makeEditable = () => {
        if (editInProgress(id)) {
            console.info(`Please finish editing existing team.`);
        } else {
            console.info(`TeamItem: makeEditable`);
            setEditable(true);
        }
    };

    const handleSave = async () => {
        console.info(`TeamItem: handleSave`);
        await teamForm.submitForm();
    };

    const handleCancelEdit = () => {
        teamForm.resetForm();
        setEditable(false);
        resetEditInProgress();
    };

    function expenseCardLimit(expenseLimit) {
        return expenseLimit > 0 ? `$${teamForm.values.teamExpenseLimit}/month` : "No Card";
    }

    return (
        <tr className={`table-row ${id === selectTeam ? 'active' : ''}`} key={id} onClick={() => { setSelectTeam(id); console.log(id) }} style={{ fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: 900, }}>
            {/* <tr className="table-row" key={id} onClick={() => {setSelectTeam(id); console.log(id)}} style={{marginTop: 20, fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: 900, backgroundColor: id === selectTeam ? 'rgba(0, 130, 244, 0.2)' :'rgba(238, 241, 243, 1)'}}> */}
            <td style={{}}>{editable ?
                (<div className="ui error field">
                    <div className="ui input">
                        <input name="teamName" id="teamName" type="text" className="center aligned" value={teamForm.values.teamName} onBlur={teamForm.handleBlur} onChange={teamForm.handleChange} />
                    </div>
                    {teamForm.errors.teamName && teamForm.touched.teamName ? (
                        <div className="error-message" role="alert" aria-atomic="true">{teamForm.errors.teamName}</div>) : ''}
                </div>)
                : name
            }
                {/*<section>
                <p>{`Object.keys(teamForm.touched).length : ${Object.keys(teamForm.touched).length}`}</p>
                <p>{`Object.keys(teamForm.errors).length : ${Object.keys(teamForm.errors).length}`}</p>
                <p>{JSON.stringify(teamForm.errors)}</p>
            </section>*/}
            </td>
            <td>
                {editable ? (<div className="ui error field">
                    <div className="ui input">
                        <input name="teamBudget" id="teamBudget" className="team-budget-input center aligned" type="number" min="1" max="9999" value={teamForm.values.teamBudget}
                            onBlur={teamForm.handleBlur} onChange={teamForm.handleChange} />
                        <div className="per-month middle-centered">/month</div>
                    </div>
                    {teamForm.errors.teamBudget && teamForm.touched.teamBudget ? (
                        <div className="error-message" role="alert" aria-atomic="true">{teamForm.errors.teamBudget}</div>) : ''}
                </div>) : `$${teamForm.values.teamBudget}/month`}
            </td>
            <td>
                {editable ? (<div className="ui error field">
                    <div className="ui input">
                        <input name="teamExpenseLimit" id="teamExpenseLimit" className="team-budget-input center aligned" type="number" min="0" max="20000" value={teamForm.values.teamExpenseLimit}
                            onBlur={teamForm.handleBlur} onChange={teamForm.handleChange} />
                        <div className="per-month middle-centered">/month</div>
                    </div>
                    {teamForm.errors.teamExpenseLimit && teamForm.touched.teamExpenseLimit ? (
                        <div className="error-message" role="alert" aria-atomic="true">{teamForm.errors.teamExpenseLimit}</div>) : ''}
                </div>) : expenseCardLimit(expenseLimit)}
            </td>
            <td>{size}</td>
            <td className="right aligned" style={{ textAlign: 'right', paddingRight: '5%', }}>
                {!editable && (<button className="ui icon button" onClick={e => makeEditable(id)}><i aria-hidden="true" className="pencil alternate icon" /></button>)}
                {!editable && (<button className="ui icon button" onClick={e => onDelete(id)}><i aria-hidden="true" className="trash icon" /></button>)}
                {!editable && (<button className="ui icon button" onClick={(e) => { nextButtonClicked(id); }}><i aria-hidden="true" className="right arrow icon" /></button>)}

                {editable && (<button className="ui button" onClick={handleCancelEdit}>Cancel</button>)}
                {editable && (
                    // <button className="ui button primary" onClick={e => handleSave(id)} disabled={teamForm.values.teamName === name && teamForm.values.teamBudget === budget && teamForm.values.teamExpenseLimit === expenseLimit}>Save</button>)}
                    <button className="ui button primary" onClick={e => handleSave(id)} disabled={!teamForm.isValid || teamForm.initialValues === teamForm.values}>Save</button>)}
            </td>
        </tr>
    );
};
